import $ from "jquery";
import moment from "moment";
import React, { Component } from "react";
import { connect } from "react-redux";
import ReactTooltip from "react-tooltip";
import "../../assets/scss/calendarDisplay.scss";
import "../../assets/scss/calendarWidget.scss";
import { getCalendarEvents } from "../../ducks/AcademicAdministrationDucks";
import { axiosPost } from "../../utils/AxiosApi";
import { URL } from "../../utils/Constants";
import { displayMessage } from "../../utils/Utils";
import { NepaliCalendar, NepaliDatePicker } from "nepali-calander";
// const { adToBs } = require('@sbmdkl/nepali-date-converter');
const { adToBs, bsToAd, calculateAge } = require("meropatro-dateconverter");

class CalendarDisplay extends Component {
  calendarComponentRef = React.createRef();
  state = {
    events: [],
    minimize: false,
    currentAcYrId: "",
    currentAcYr: "",
    currentAcYrName: "",
    systemDefaultAcYr: "",
    calendarDate: "",
    adCalendar: false,
    bsCalendar: true,
    calendarMode: localStorage.getItem("calendar-mode") || "bs",
    clickedToday: false,
    showCalendar: false,
  };

  componentDidMount() {
    // this.setState({
    //   adCalendar: localStorage.getItem('calendar-mode') === 'ad',
    //   bsCalendar: localStorage.getItem('calendar-mode') === 'bs',
    // }, () =>{
    // })
    this.getUserCurrentAcademicYear();
    ReactTooltip.rebuild();
    this.addMinimizeClass();
    setTimeout(() => {
      this.setState({ showCalendar: true });
    }, 3000);
  }

  addMinimizeClass = () => {
    let self = this;
    $(window).on("load", function () {
      if ($(window).width() <= 768) {
        self.setState({ minimize: true });
      }
    });
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.assessmentModuleandEducationLevel !==
      this.props.assessmentModuleandEducationLevel
    ) {
      this.props.getCalendarEvents(
        this.props.assessmentModuleandEducationLevel,
      );
      ReactTooltip.rebuild();
    }
    // if (prevState.calendarDate !== this.state.calendarDate) {
    //   this.renderNepaliCalendate()
    //   this.setState({calendarDate: ""});
    // }
    // this.renderNepaliDates();
  }

  filterSameCalendarEvents = () => {
    let events = [...this.props.calendarEvents];
    events.forEach((event) => {
      event.end = moment(event.end).format("YYYY-MM-DD");
      event.start = moment(event.start).format("YYYY-MM-DD");
    });
    const unique = [];
    events.map((x) =>
      unique.filter(
        (a) =>
          a.color == x.color &&
          a.title == x.title &&
          a.start == x.start &&
          a.end == x.end,
      ).length > 0
        ? null
        : unique.push(x),
    );
    // this.setState({ uniqueCalendarEvents: unique });
    return unique;
  };

  getUserCurrentAcademicYear = () => {
    axiosPost(URL.selectUserAcademicYear, {}, (response) => {
      if (response.status === 200) {
        if (response.data.data) {
          this.setState({
            currentAcYr: response.data.data,
            currentAcYrId: response.data.data.academicYearId,
            currentAcYrName: response.data.data.academicYearName,
          });
        } else {
          this.getCurrentAcademicYear();
        }
      }
    });
  };

  getCurrentAcademicYear = () => {
    let data = {
      isCurrent: "true",
    };

    axiosPost(URL.getAcademicYears, data, (response) => {
      if (response.status === 200) {
        if (response.data.data && response.data.data.length > 0) {
          this.setState({
            currentAcYr: response.data.data[0],
            currentAcYrId: response.data.data[0].id,
            currentAcYrName: response.data.data[0].name,
          });
        }
      }
    });
  };

  handleEventPositioned = (arg) => {
    if (arg.event.extendedProps.description) {
      arg.el.setAttribute("data-tip", arg.event.extendedProps.description);
      ReactTooltip.rebuild();
    }
  };

  renderEvents = (arg) => {
    if (arg.event.start.getMonth() !== arg.view.currentStart.getMonth()) {
      return false;
    }
  };

  minimizeCalendarContainer = () => {
    // this.renderNepaliDates();
    this.setState({ minimize: !this.state.minimize });
  };

  handleChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;

    this.setState((prevState) => {
      if (name === "calendarDate" && value !== "") {
        return { [name]: value };
      }
    });
  };

  goToDate = (e) => {
    e.preventDefault();
    if (this.state.calendarDate !== "") {
      let calendarApi = this.calendarComponentRef.current.getApi();

      calendarApi.gotoDate(this.state.calendarDate);

      $('.fc-day[data-date="' + this.state.calendarDate + '"]').css(
        "background-color",
        "rgba(66, 118, 234, 0.3)",
      );
    }
    // else if (){

    // }
    else {
      displayMessage("Oops", "Please select date first");
    }
  };

  today = (e) => {
    this.setState({ calendarDate: new Date().toISOString().substring(0, 10) });
  };

  devanagariDigits = {
    0: "०",
    1: "१",
    2: "२",
    3: "३",
    4: "४",
    5: "५",
    6: "६",
    7: "७",
    8: "८",
    9: "९",
  };

  nepaliMonths = [
    "बैशाख", // April-May
    "जेष्ठ", // May-June
    "असार", // June-July
    "श्रावण", // July-August
    "भाद्र", // August-September
    "आश्विन", // September-October
    "कार्तिक", // October-November
    "मंसिर", // November-December
    "पौष", // December-January
    "माघ", // January-February
    "फाल्गुन", // February-March
    "चैत्र", // March-April
  ];

  renderNepaliDates = () => {
    const dates = document.querySelectorAll(".fc-day");
    // const currentDate = new Date();
    const currentDate = new Date(this.state?.infoDate?.view.currentStart);
    const currentMonth = currentDate?.getMonth();
    const currentYear = currentDate?.getFullYear();

    dates.forEach((date) => {
      const dateStr = date.getAttribute("data-date");
      const nepalTime = new Date(dateStr);
      const formattedDate = moment(nepalTime).format("YYYY-MM-DD");

      // const nepaliDate = moment(adToBs(formattedDate)).format("DD");
      const nepaliDate = adToBs(formattedDate).split("-")[2];

      const nepaliDateDevanagari = nepaliDate.replace(
        /[0-9]/g,
        (match) => this.devanagariDigits[match],
      );
      const existingDiv = date.querySelector("span");
      if (existingDiv) {
        existingDiv.remove();
      }
      const newDiv = document.createElement("span");
      newDiv.style.position = "absolute";
      newDiv.style.bottom = "0";
      newDiv.style.marginLeft = "2px";

      if (
        nepalTime?.getMonth() !== currentMonth ||
        nepalTime.getFullYear() !== currentYear
      ) {
        newDiv.style.opacity = "0.3";
      }

      newDiv.innerText = nepaliDateDevanagari;
      // added nepali font styles as nep dates appended was being replaced in browser by eng dates
      newDiv.style.cssText = `
      position: absolute;
      bottom: 0;
      marginLeft: 5px;
      font-family: 'NepaliFont', Arial;
      opacity: ${
        nepalTime?.getMonth() !== currentMonth ||
        nepalTime?.getFullYear() !== currentYear
          ? "0.3"
          : "1"
      };`;
      date.append(newDiv);
    });

    if (this.state.infoDate != null) {
      const currentDate = moment(
        new Date(this.state?.infoDate?.view.currentStart),
      ).format("YYYY-MM-DD");

      const currentDateEnd = moment(
        new Date(this.state?.infoDate?.view.currentEnd),
      ).format("YYYY-MM-DD");

      const nepaliDate = adToBs(currentDate);
      const nepaliDateEnd = adToBs(currentDateEnd);

      const nepaliMonth =
        this.nepaliMonths[moment(nepaliDate).format("MM") - 1];
      const nepaliMonthEnd =
        this.nepaliMonths[moment(nepaliDateEnd).format("MM") - 1];
      const nepaliMonthYearNp = `(${nepaliMonth}-${nepaliMonthEnd}, ${moment(
        nepaliDate,
      )
        .format("YYYY")
        .replace(/[0-9]/g, (match) => this.devanagariDigits[match])})`;

      // // Append the Nepali month and year to the header title
      const h2Header = document.getElementsByTagName("h2");
      const existingSpan = h2Header[0]?.querySelector("span");

      if (existingSpan) {
        existingSpan.remove();
      }

      const newSpan = document.createElement("span");
      newSpan.innerText = nepaliMonthYearNp;
      if (h2Header[0]) {
        h2Header[0].append(newSpan);
      }
    }

    //  insert day values in nepali
    let days = document.querySelectorAll(
      ".fc-day-header.fc-widget-header.fc-sun, .fc-day-header.fc-widget-header.fc-mon, .fc-day-header.fc-widget-header.fc-tue, .fc-day-header.fc-widget-header.fc-wed, .fc-day-header.fc-widget-header.fc-thu, .fc-day-header.fc-widget-header.fc-fri, .fc-day-header.fc-widget-header.fc-sat",
    );
    let nepaliDays = ["आइत", "सोम", "मंगल", "बुध", "बिही", "शुक्र", "शनि"];
    // let secondWeekDays = Array.prototype.slice.call(days, 7);
    days.forEach((day, index) => {
      let nepaliDay = nepaliDays[index % 7];
      let words = day.textContent.split("/");
      let filteredWords = words.filter((word) => word !== nepaliDay);
      day.textContent =
        filteredWords.join("/") +
        (filteredWords.length > 0 ? "/" : "") +
        nepaliDay;
    });
  };

  handleChangeCalendarToggle = (e) => {
    const { name, checked } = e.target;
    if (checked) {
      this.setState({
        bsCalendar: true,
        adCalendar: false,
      });
    } else {
      this.setState({
        adCalendar: true,
        bsCalendar: false,
      });
    }
  };

  renderNepaliCalendate = () => {
    if (!this.state.showCalendar) return null;
    return (
      <NepaliCalendar
        events={this.filterSameCalendarEvents() || []}
        calendarMode={localStorage.getItem("calendar-mode")}
        showToggle={true}
        isClickable={false}
        showNationalHoliday={false}
        value={this.state.calendarDate}
      />
    );
  };

  render() {
    return (
      <div
        id="tt-calendarContainer"
        className={
          this.state.minimize
            ? "tt-group-container minimize"
            : "tt-group-container tt-calendar-container"
        }
      >
        <div
          className="tt-group-header d-flex align-items-center justify-content-between"
          onDoubleClick={this.minimizeCalendarContainer}
          data-tip="Double click to expand and collapse this widget"
        >
          <div>Calendar</div>
        </div>
        <div className="tt-calendarBox profileCalendar">
          {this.renderNepaliCalendate()}
        </div>
        <div className="tt-group-header" style={{ marginTop: "1rem" }}>
          <div className="row">
            <div className="col calendarGOTODATE">
              <NepaliDatePicker
                type="input"
                calendarMode={this.state.calendar}
                showToggle={true}
                showNationalHoliday={false}
                events={[]}
                onDateSelect={(date) =>
                  this.handleChange({
                    target: { name: "calendarDate", value: date.ad.date },
                  })
                }
                value={this.state.calendarDate}
              />
            </div>
            <div className="col-md-auto col-sm-auto mt-1 calendarGOTODATEBUTTON">
              {/* <button
                className="tt-button tt-button-primary mr-2"
                onClick={this.goToDate}
              >
                Go to Date
              </button> */}
              <button
                className="tt-button tt-button-primary todayCalendar"
                onClick={this.today}
              >
                Today
              </button>
            </div>
          </div>
        </div>
        <ReactTooltip globalEventOff="click"></ReactTooltip>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  calendarEvents: state.academicAdministration.calendarEvents,
});

const mapActionToProps = {
  getCalendarEvents,
};

export default connect(mapStateToProps, mapActionToProps)(CalendarDisplay);
